<template>
    <Bar :chart-options="chartOptions" :chart-data="chartData" />
</template>
  
<script>
import { Bar } from 'vue-chartjs/legacy'
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    name: 'BarChart',
    components: {
        Bar
    },
    props: {
        data: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            chartData: [],
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: 'y'

            }
        }
    },
    computed: {
        dynamicChartData() {
            return {
                labels: this.data.map((item) => item.nama),
                datasets: [
                    {
                        label: '',
                        backgroundColor: 'rgb(96, 204, 219)',
                        data: this.data.map((item) => item.jumlah)
                    }
                ]
            }
        }
    },
    watch: {
        data: {
            handler(newData) {
                this.chartData = this.dynamicChartData;
            },
            immediate: true
        }
    },
    mounted() {
        this.chartData = this.dynamicChartData;
    }
}
</script>
  